/* Floodlight · ss-search.js (core) — predictive search overlay (/search/suggest.json) */
(function () {
  'use strict';
  if (window.SS_LOADED_search) return;
  window.SS_LOADED_search = true;
  var SS = window.SS;
  if (!SS) return;
  var doc = document, C = SS.config || {}, R = C.routes || {}, S = C.strings || {};
  var PANEL = 'ss-search';
  var timer = 0, ctrl = null, seq = 0;

  function el(sel) { var p = doc.getElementById(PANEL); return p ? p.querySelector(sel) : null; }
  function fmt(tpl, n) { return String(tpl || '').replace('%n', n); }
  function countLabel(n) { return fmt(n === 1 ? (S.results_one || '%n result') : (S.results_other || '%n results'), n); }
  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }
  function kindOf(tags, type) {
    var k = C.kindTags || {};
    var list = (tags || []).map(function (t) { return String(t).toLowerCase(); });
    if (k.training && list.indexOf(String(k.training).toLowerCase()) >= 0) return S.training || 'Training';
    if (k.match && list.indexOf(String(k.match).toLowerCase()) >= 0) return S.match || 'Match';
    return type || '';
  }
  function guideTag(tags) {
    var pri = C.guideTags || [];
    var lower = (tags || []).map(function (t) { return String(t).toLowerCase(); });
    for (var i = 0; i < pri.length; i++) {
      var at = lower.indexOf(String(pri[i]).toLowerCase());
      if (at >= 0) return tags[at];
    }
    return (tags && tags[0]) || '';
  }
  function minutes(bodyHtml) {
    var txt = String(bodyHtml || '').replace(/<[^>]*>/g, ' ').replace(/&[a-z#0-9]+;/gi, ' ').trim();
    var words = txt ? txt.split(/\s+/).length : 0;
    return Math.max(2, Math.round(words / (Number(C.wpm) || 200)));
  }
  function row(o) {
    var tpl = doc.getElementById('ss-result-tpl');
    if (!tpl || !tpl.content) return null;
    var node = tpl.content.firstElementChild.cloneNode(true);
    node.href = o.url;
    var img = node.querySelector('img');
    if (img) {
      if (o.img) { img.src = sized(o.img, 128); img.alt = o.alt || o.title; }
      else img.remove();
    }
    var b = node.querySelector('b');
    if (b) b.textContent = o.title;
    var sub = node.querySelector('.sub');
    if (sub) sub.textContent = o.sub || '';
    var price = node.querySelector('.price');
    if (price) { if (o.price) price.textContent = o.price; else price.remove(); }
    return node;
  }
  function show(state, hint) {
    var def = el('[data-search-default]'), res = el('[data-search-results]'), empty = el('[data-search-empty]'), h = el('[data-search-hint]');
    if (def) def.hidden = state !== 'default';
    if (res) res.hidden = state !== 'results';
    if (empty) empty.hidden = state !== 'empty';
    if (h) h.textContent = hint;
    if (state === 'empty') {
      var copy = el('[data-search-default-copy]');
      if (copy && def && !copy.childElementCount) copy.innerHTML = def.innerHTML;
    }
  }
  function reset() {
    seq++;
    if (ctrl) { try { ctrl.abort(); } catch (e) {} ctrl = null; }
    show('default', S.ourFootballs || 'Our footballs');
  }
  function render(data, q) {
    var r = (data && data.resources && data.resources.results) || {};
    var list = [];
    (r.products || []).forEach(function (p) {
      var title = String(p.title || '').split(' — ')[0];
      var kind = kindOf(p.tags, p.type);
      var cents = p.price_min != null ? p.price_min : p.price;
      list.push({
        url: p.url, title: title,
        img: (p.featured_image && p.featured_image.url) || p.image,
        alt: (p.featured_image && p.featured_image.alt) || title,
        sub: (S.sizeFive || 'Size 5') + (kind ? ' · ' + kind + ' ' + (S.football || 'football') : ''),
        price: cents != null ? SS.money(Math.round(parseFloat(cents) * 100)) : ''
      });
    });
    (r.articles || []).forEach(function (a) {
      var tag = guideTag(a.tags);
      list.push({
        url: a.url, title: a.title, img: a.image, alt: a.title,
        sub: [S.guide || 'Guide', tag, fmt(S.readTime || '%n min read', minutes(a.body || a.summary_html))].filter(Boolean).join(' · ')
      });
    });
    (r.pages || []).forEach(function (pg) {
      list.push({ url: pg.url, title: pg.title, sub: S.page || 'Page' });
    });
    var box = el('[data-search-results]');
    if (!box) return;
    box.innerHTML = '';
    list.forEach(function (o) { var n = row(o); if (n) box.appendChild(n); });
    if (list.length) show('results', countLabel(list.length));
    else show('empty', countLabel(0));
  }
  function run(q) {
    var mine = ++seq;
    if (ctrl) { try { ctrl.abort(); } catch (e) {} }
    ctrl = window.AbortController ? new AbortController() : null;
    var panel = doc.getElementById(PANEL);
    var limit = (panel && panel.getAttribute('data-limit')) || 6;
    var url = (R.suggest || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,article,page&resources[limit]=' + limit +
      '&resources[limit_scope]=each&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,tag,variants.title';
    SS.fetchJSON(url, { signal: ctrl ? ctrl.signal : undefined }).then(function (data) {
      if (mine !== seq) return;
      render(data, q);
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      if (mine === seq) show('empty', countLabel(0));
    });
  }
  function onInput(input) {
    clearTimeout(timer);
    var q = input.value.trim();
    if (!q) { reset(); return; }
    timer = setTimeout(function () { run(q); }, 180);
  }

  doc.addEventListener('input', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-search-input')) onInput(e.target);
  });
  doc.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-search-chip]');
    if (!chip || !chip.closest('#' + PANEL)) return;
    e.preventDefault();
    var input = el('[data-search-input]');
    if (!input) return;
    input.value = chip.getAttribute('data-search-chip') || chip.textContent.trim();
    try { input.focus({ preventScroll: true }); } catch (err) {}
    clearTimeout(timer);
    run(input.value.trim());
  });
  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.hasAttribute || !form.hasAttribute('data-search-form')) return;
    var input = form.querySelector('[data-search-input]');
    if (input && !input.value.trim()) { e.preventDefault(); input.focus(); }
  });
  SS.on('overlay:open', function (d) {
    if (d.id !== PANEL) return;
    var input = el('[data-search-input]');
    if (input) { try { input.focus({ preventScroll: true }); input.select(); } catch (e) {} }
  });
  SS.on('overlay:close', function (d) {
    if (d.id !== PANEL) return;
    clearTimeout(timer);
    var input = el('[data-search-input]');
    if (input) input.value = '';
    reset();
  });
})();
